import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@sevensenders/component-library';

export default function StationCell({ value }) {
  if (!value) {
    return null;
  }

  const address = value.address ?? {};
  const partner = value.partner ?? {};

  const { city = '' } = address;
  const { public_name = '' } = partner;

  return (
    <>
      {city && <Text inline={false}>{city}</Text>}
      {public_name && (
        <Text secondary small inline={false}>
          {public_name}
        </Text>
      )}
    </>
  );
}

StationCell.propTypes = {
  value: PropTypes.shape({
    address: PropTypes.shape({
      city: PropTypes.string,
    }),
    partner: PropTypes.shape({
      public_name: PropTypes.string,
    }),
  }).isRequired,
};
